import square from "@/data/eminenceSquare.json";

// Oct 14 2026 · Karine ask — every one of the 24 Éminence rituals has its own
// photo (/public/eminence/<key>.jpg) and an exact Square variation id so the
// website's Book buttons and the booking picker show the same thing.
const BY_VARIATION = Object.fromEntries(Object.entries(square).map(([key, v]) => [v.variation_id, key]));

export const eminencePhoto = (key) => `/eminence/${key}.jpg`;
export const eminenceVariationId = (key) => square[key]?.variation_id || "";
export const eminencePhotoForVariation = (variationId) => {
  const key = BY_VARIATION[variationId];
  return key ? eminencePhoto(key) : null;
};
